import i18n, { InitOptions } from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE } from "../config";
import { languagesWithCImode } from "./languages";

const missingKeyHandler: InitOptions["missingKeyHandler"] = (
  lngs,
  ns,
  key,
  fallbackVal,
  updateMissing,
  opts,
) => {
  // eslint-disable-next-line no-console
  console.warn(
    `i18n: Missing '${lngs.join(", ")}' translation for '${ns}:${key}'.`,
    opts,
  );
};

// for all options read: https://www.i18next.com/overview/configuration-options
const options: InitOptions = {
  defaultNS: undefined,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: [],
  supportedLngs: languagesWithCImode,
  // call missingKeyHandler on missing keys
  saveMissing: true,
  missingKeyHandler,
  // when translation is missing, show full key including the namespace
  appendNamespaceToMissingKey: true,
  // prefixes the namespace to the returned key when using lng: 'cimode'
  appendNamespaceToCIMode: true,
  interpolation: {
    // not needed for react as it escapes by default
    escapeValue: false,
  },
  backend: {
    loadPath: "/assets/locales/{{ns}}.{{lng}}.json",
  },
  load: "currentOnly",
  preload: [DEFAULT_LANGUAGE],

  // load only bare minimum, each app has to load it's translations
  ns: ["react-common-translation", "react-api-core"],
  react: {
    useSuspense: true,
  },
};

i18n.createInstance().use(initReactI18next).use(HttpBackend).init(options);
